import { isServer } from './utils';

// Globals the platform host injects into the browser shell. Their presence means the app
// runs cross-origin against the platform apiDomain, so its requests must carry the session
// cookie. Hot-path callers guard isServer before this runs (short-circuit), so window is safe.
export const isCorsMode = (): boolean =>
  '__unifyBaseUrl' in window || '__unifyTenantURI' in window;

// Credentials mode matching executeFetch, for non-ky consumers that must replicate its
// cross-origin CORS behaviour (e.g. wavesurfer's audio-decode fetch). Pass the request's
// meta.apiDomain when known — a set apiDomain forces credentials exactly like executeFetch's
// `apiDomain ?? isCorsMode()`, so an explicit cross-origin target (matrix-native, preview flow)
// is honoured even when the platform-shell globals are absent. Undefined on the server and
// outside a platform shell with no apiDomain, so those requests stay anonymous.
export const getPlatformFetchCredentials = (
  apiDomain?: string,
): RequestCredentials | undefined => {
  if (isServer()) return undefined;
  return (apiDomain ?? isCorsMode()) ? 'include' : undefined;
};
